import { AbodeAggregateMarketConditions } from '@aloft/toolkit-shared';

import { pngChartMaker } from '../../../components/graphs/pngChartMaker.tsx';
import { AbsorptionRate } from '../../appraisifyCommentary/components/graphs/AbsorptionRate.tsx';
import { MedianSalePriceToListPrice } from '../../appraisifyCommentary/components/graphs/MediaSalePricetoListPrice.tsx';
import { MedianDOM } from '../../appraisifyCommentary/components/graphs/MedianDOM.tsx';
import { MedianListPrice } from '../../appraisifyCommentary/components/graphs/MedianListPrice.tsx';
import { MedianSalePrice } from '../../appraisifyCommentary/components/graphs/MedianSalePrice.tsx';
import { MonthsOfHousingSupply } from '../../appraisifyCommentary/components/graphs/MonthsOfHousingSupply.tsx';
import { TotalComparableListings } from '../../appraisifyCommentary/components/graphs/TotalComparableListings.tsx';
import { TotalComparableSales } from '../../appraisifyCommentary/components/graphs/TotalComparableSales.tsx';

export const MARKET_CONDITION_GRAPH_TITLES = [
  'Total # of Comparable Sales (Settled)',
  'Absorption Rate (Total Sales Per Month)',
  'Total # of Comparable Active Listings',
  'Months of Housing Supply',
  'Median Comp. Sale Price',
  'Median Comp. List Price',
  'Median Sale Price as % Of List Price',
  'Median Comp. Sale DOM',
] as const;

const MARKET_CONDITION_GRAPH_COMPONENTS = [
  TotalComparableSales,
  AbsorptionRate,
  TotalComparableListings,
  MonthsOfHousingSupply,
  MedianSalePrice,
  MedianListPrice,
  MedianSalePriceToListPrice,
  MedianDOM,
] as const;

export const generateMarketConditionGraphImages = async (
  marketAggregateData?: AbodeAggregateMarketConditions,
): Promise<Array<string | undefined>> => {
  if (!marketAggregateData?.monthlyData.length) return [];

  const images: Array<string | undefined> = [];
  for (const Component of MARKET_CONDITION_GRAPH_COMPONENTS) {
    images.push(
      await pngChartMaker(Component, { data: marketAggregateData, disableAnimations: true }, 1400, 350),
    );
  }
  return images;
};
